import * as pessoaApi from '@/api/pessoa'
import * as fasesApi from '@/api/fases'
import * as usuarioApi from '@/api/usuario'
// import * as carrinhoApi from '@/api/carrinho'
// import _ from 'lodash'

/* eslint-disable */

const set = property => (state, payload) => (state[property] = payload)
const res = (property, commit) => res => {
  commit(property, res.hasOwnProperty('data') ? res.data : res)
  return res
}

const state = {
  pessoas: [],
  fases: [],
  usuarios: []
}

const mutations = {
  PESSOAS: set('pessoas'),
  FASES: set('fases'),
  USUARIOS: set('usuarios')
}

const actions = {
  loadPessoas: ({ commit }, data = []) => pessoaApi.list(...data).then(res('PESSOAS', commit)),
  loadUsuarios: ({ commit }, data = []) => usuarioApi.list(...data).then(res('USUARIOS', commit)),
  loadFases: ({ commit }) => fasesApi.list({}, true)
    .then(res => {
      commit('FASES', res)
      return res
    })
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
